import cx from '@utils/cx.util';
import { type TSitewideBannerScene } from './types';
import CountdownTimer from './CountdownTimer';
import { Link } from '@components/Link';

const Scene: React.FC<{ scene: TSitewideBannerScene }> = ({ scene }) => {
  const Comp: any = scene.destinationUrl ? Link : 'div';
  const props = scene.destinationUrl ? { href: scene.destinationUrl } : {};

  return (
    <Comp
      {...props}
      className='tw:flex tw:min-h-[48px] tw:w-full tw:shrink-0 tw:grow-0 tw:flex-col tw:items-center tw:justify-center tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap tw:px-0 tw:py-3 tw:text-sm tw:font-bold tw:no-underline tw:hover:no-underline tw:md:text-base tw:lg:flex-row tw:lg:gap-1 tw:[&>p]:!m-0'
      style={{ backgroundColor: scene.backgroundColor }}>
      <div className='tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-2'>
        {scene.lines?.map((line, idx) => (
          <p
            key={idx}
            style={{ color: line.textColor }}
            className={cx(
              'tw:mb-0 tw:inline-block tw:animate-[fadeIn_0.5s_ease-in-out] tw:text-sm tw:leading-none tw:md:text-base',
              {
                'tw:lg:text-xs': line.textSize === 'xs',
                'tw:lg:text-sm': line.textSize === 'sm',
                'tw:lg:text-base': line.textSize === 'md',
                'tw:lg:text-lg': line.textSize === 'lg',
                'tw:lg:text-xl': line.textSize === 'xl',
                'tw:text-xl tw:lg:text-2xl': line.textSize === '2xl',
              }
            )}
            dangerouslySetInnerHTML={{ __html: line.text }}
          />
        ))}

        {scene.isCountdown && scene.endAt && <CountdownTimer targetDate={scene.endAt} />}
      </div>
    </Comp>
  );
};

export default Scene;
